import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = {
  key: 0,
  class: "modal-sidebar"
}
const _hoisted_5 = { class: "modal-main" }

import { ref, onMounted, onUnmounted } from "vue";
import PdfViewerNutrient from "@/components/PdfViewerNutrient.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentViewerModal',
  props: {
    documentId: {},
    documentName: {},
    onClose: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const docId = ref(props.documentId); // server is expecting docId

const handleOverlayClick = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  if (target.classList.contains("modal-overlay")) {
    props.onClose();
  }
};

onMounted(() => {
  document.body.style.overflow = "hidden";
});

onUnmounted(() => {
  document.body.style.overflow = "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: handleOverlayClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(__props.documentName), 1),
        _createElementVNode("span", {
          class: "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onClose && __props.onClose(...args)))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$slots.sidebar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "sidebar")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(PdfViewerNutrient, { docId: docId.value }, null, 8, ["docId"])
        ])
      ])
    ])
  ]))
}
}

})